import { toCurrency } from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter/utilities';
import { getFilterInputByValue } from '@source/store/filters';
import { useTranslate } from '@source/utilities/hooks';

export const transformTagLabel = (name: string, value: string) => {
    const filterInput = getFilterInputByValue(name, value);

    const replacer = { id: 'Amount', value };

    switch (name) {
        case FILTER_NAMES.rooms:
            return useTranslate('Filters.Rooms.selectedLabel', {
                replace: [replacer],
            });
        case FILTER_NAMES.livingArea:
            return useTranslate('Filters.LivingArea.selectedLabel', {
                replace: [replacer],
            });
        case FILTER_NAMES.plotArea:
            return useTranslate('Filters.PlotArea.selectedLabel', {
                replace: [replacer],
            });
        case FILTER_NAMES.priceRange:
            const prices = value.split('.');

            return `${toCurrency(parseInt(prices[prices.length > 2 ? 1 : 0]))} - ${toCurrency(
                parseInt(prices[prices.length > 2 ? 2 : 1]),
            )}`;
        default:
            return filterInput.label || '';
    }
};
